export default object => Object.keys(object || {}).length === 0;
